export const VersionSorter = {
    methods: {
        sortVersionsByLength(allVersions = []) {
            const sorter = (firstVersion, secondVersion) => {
                const isNumber = (v) => (+v).toString() === v
                const firstVersionLength = firstVersion.length?.label.match(/\d+|\D+/g)
                const secondVersionLength = secondVersion.length?.label.match(/\d+|\D+/g)
                let i = 0
                let len;
                if (firstVersionLength && secondVersionLength) {
                    len = Math.min(firstVersionLength?.length, secondVersionLength?.length)
                } else {
                    return 0
                }
                while(i < len && firstVersionLength[i] === secondVersionLength[i]) {
                    i++
                }
                if(i === len) {
                    return firstVersionLength.length - secondVersionLength.length
                }

                if(isNumber(firstVersionLength[i]) && isNumber(secondVersionLength[i])) {
                    return firstVersionLength[i] - secondVersionLength[i]
                }

                return firstVersionLength[i].localeCompare(secondVersionLength[i])
            }
            return allVersions.sort(sorter)
        }
    }
}
